(function(XHR) {
  "use strict";

  const open = XHR.prototype.open;

  XHR.prototype.open = function(method, url, async, user, pass) {
    const cleanUrl = url.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?\//, '/');
    this._url = cleanUrl;
    open.call(this, method, cleanUrl, async, user, pass);
  };
})(XMLHttpRequest);

(function () {
  var copy = {
    en: [
      'You must be logged in to see products, prices and inventory.',
      'Search for products quickly using the search bar and filters, enter the quantity you want, and add it to the cart. Once you have added all the products you need, check out from the cart page.',
      'Download our full product database as an Excel file and import it into your own system. You will find all the relevant data in it, including the product SKU, name, description, image, EAN code, your buying price and the RRP.',
      'Please use the GENERATORS to customise your products at the beginning of your order process. Using them later in the process may result in incorrect prices for the products you have created.'
    ],
    it: [
      'Devi aver effettuato l’accesso per vedere i prodotti, i prezzi e le disponibilità.',
      'Cerca i prodotti in fretta con la barra di ricerca e i filtri, inserisci la quantità che ti serve e aggiungila al carrello. Quando hai aggiunto tutti i prodotti che ti servono, concludi l’ordine dalla pagina del carrello.',
      'Scarica il file Excel con l’intero database prodotti e importalo nel tuo sistema. Ci trovi tutti i dati utili, tra cui SKU, nome, descrizione, immagine, codice EAN, il tuo prezzo di acquisto e il prezzo di vendita consigliato (RRP).',
      'Usa i GENERATORS per personalizzare i prodotti all’inizio dell’ordine. Se li usi più avanti, i prezzi dei prodotti che hai creato possono risultare sbagliati.'
    ],
    fr: [
      'Vous devez être connecté pour voir les produits, les prix et les stocks.',
      'Recherchez rapidement les produits avec la barre de recherche et les filtres, indiquez la quantité souhaitée et ajoutez-la au panier. Une fois tous les produits ajoutés, validez la commande depuis la page du panier.',
      'Téléchargez notre base produits complète au format Excel pour l’importer dans votre système. Vous y trouverez toutes les données utiles, notamment le SKU, le nom, la description, l’image, le code EAN, votre prix d’achat et le prix de vente conseillé (RRP).',
      'Veuillez utiliser les GENERATORS pour personnaliser vos produits au début de la commande. Les utiliser plus tard peut entraîner des prix incorrects pour les produits que vous avez créés.'
    ],
    de: [
      'Sie müssen angemeldet sein, um Produkte, Preise und Bestände zu sehen.',
      'Suchen Sie Produkte schnell über die Suchleiste und die Filter, geben Sie die gewünschte Menge ein und legen Sie sie in den Warenkorb. Wenn Sie alle gewünschten Produkte hinzugefügt haben, schließen Sie die Bestellung auf der Warenkorbseite ab.',
      'Laden Sie unsere vollständige Produktdatenbank als Excel-Datei herunter und importieren Sie sie in Ihr eigenes System. Darin finden Sie alle relevanten Daten, einschließlich SKU, Name, Beschreibung, Bild, EAN-Code, Ihrem Einkaufspreis und der unverbindlichen Preisempfehlung (RRP).',
      'Bitte verwenden Sie die GENERATORS, um Ihre Produkte zu Beginn des Bestellvorgangs anzupassen. Wenn Sie sie später verwenden, können die Preise der Produkte, die Sie erstellt haben, falsch sein.'
    ],
    es: [
      'Debes iniciar sesión para ver los productos, los precios y el inventario.',
      'Busca productos rápidamente con la barra de búsqueda y los filtros, indica la cantidad que quieres y añádela al carrito. Cuando hayas añadido todos los productos que necesitas, finaliza el pedido desde la página del carrito.',
      'Descarga nuestra base de datos completa de productos en Excel para importarla en tu propio sistema. Encontrarás todos los datos relevantes, incluidos el SKU, el nombre, la descripción, la imagen, el código EAN, tu precio de compra y el PVP (RRP).',
      'Usa los GENERATORS para personalizar tus productos al principio del pedido. Si los usas más adelante, los precios de los productos que hayas creado pueden ser incorrectos.'
    ]
  };

  function bannerHtml(lang) {
    var lines = copy[lang] || copy.en;
    return lines.join('<br /><br />');
  }

  function apply() {
    var box = document.getElementById('order_form_desc_container');
    if (!box) return false;
    var span = box.querySelector('span');
    if (!span) return false;
    var lang = (window.Shopify && window.Shopify.locale) || 'en';
    if (span.getAttribute('data-play-banner') === lang) return true;
    span.innerHTML = bannerHtml(lang);
    span.setAttribute('data-play-banner', lang);
    return true;
  }

  function watch() {
    apply();
    var box = document.getElementById('order_form_desc_container');
    if (!box || box.getAttribute('data-play-banner-watch')) return;
    box.setAttribute('data-play-banner-watch', '1');
    new MutationObserver(function () {
      apply();
    }).observe(box, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    if (document.getElementById('order_form_desc_container')) watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
